/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import React, { useState, useEffect } from 'react';
import DateTimePickerModal from './DateTimePickerModal';

// 👉 IMPORTANT helper
import { toLocalISO } from '../utils/dateHelper';
import Modal from './Modal';
import { useTranslation } from '../hooks/useTranslation';

const EditorialChangePopup = ({ isOpen, onBack, onPublish }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [tempDate, setTempDate] = useState('');
  const [showCalendar, setShowCalendar] = useState(false);

  const t = useTranslation();
  // 👉 Default = Next month 1st date at 08:00 (no timezone issue)
  useEffect(() => {
    const now = new Date();
    const defaultDate = new Date(now.getFullYear(), now.getMonth() + 1, 1, 8, 0);

    const iso = toLocalISO(defaultDate);

    setSelectedDate(iso);
    setTempDate(iso);
  }, []);

  if (!isOpen) return null;

  // 👉 Display formatted date
  const formattedDisplay = (() => {
    if (!selectedDate) return '';
    const d = new Date(selectedDate);
    const month = d.toLocaleString('default', { month: 'long' });
    const day = d.getDate();
    const time = d.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${month} ${day} : ${time}`;
  })();

  const handleSaveDateTime = (value) => {
    const iso = toLocalISO(value); // ✨ fixed timezone
    setSelectedDate(iso);
    setTempDate(iso);
    setShowCalendar(false);
  };

  return (
    <Modal modalStyle={{ width: '550px' }}>
      <h2 className="content_change_popup  fs-12 fw-500 global-color mt-0 mb-5 d-block">
        {' '}
        {t('publish_process')}{' '}
      </h2>
      <h3 className="content_change_popup  fs-12 fw-500 global-color mb-5 d-block bb-1">
        {' '}
        {t('schedule_publishing')}
      </h3>
      <p className="mt-0 fs-12">{t('please_set_the_date_for_publishing_the_model')}</p>
      {/* Immediately */}
      <h3 className="content_change_popup  fs-12 fw-500 global-color mb-5 d-block">
        {t('date_of_publishing')}
      </h3>
      <div className="b-1 p-10 lable_list">
        <label className="fs-12">
          <input
            type="radio"
            name="schedule"
            value="immediately"
            checked={selectedOption === 'immediately'}
            onChange={() => {
              setSelectedOption('immediately');
              setShowCalendar(false);
            }}
          />
          <span> {t('immediately')} </span>
        </label>

        {/* Custom date time */}
        <label className="fs-12">
          <input
            type="radio"
            name="schedule"
            value="custom"
            checked={selectedOption === 'custom'}
            onChange={() => setSelectedOption('custom')}
          />
          <span>
            {formattedDisplay}
            <button
              className="btn-small ml-10"
              onClick={(e) => {
                e.preventDefault();
                setTempDate(selectedDate);
                setShowCalendar(true);
              }}
            >
              {t('edit')}
            </button>
          </span>
        </label>
      </div>

      {/* Calendar Modal */}
      <DateTimePickerModal
        isOpen={showCalendar}
        onClose={() => setShowCalendar(false)}
        onSave={handleSaveDateTime}
        minDate={new Date()}
      />

      <div style={styles.footer}>
        <button className="popup-button button_secondary" onClick={onBack}>
          {t('back')}
        </button>

        <button
          className="popup-button button_primary"
          style={{
            // background: selectedOption ? "#28a745" : "#c4c4c4",
            cursor: selectedOption ? 'pointer' : 'not-allowed',
          }}
          disabled={!selectedOption}
          onClick={() => {
            let finalDate = null;
            if (selectedOption === 'custom') {
              finalDate = new Date(selectedDate).toISOString();
            }
            onPublish({
              scheduleType: selectedOption,
              date: finalDate,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            });
          }}
        >
          {t('Publish')}
        </button>
      </div>
    </Modal>
  );
};

const styles = {
  heading: { fontSize: '22px', fontWeight: '600' },
  subheading: { fontSize: '12px', marginTop: '10px' },

  optionRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '12px',
    gap: '6px',
  },

  inlineEditBtn: {
    marginLeft: '10px',
    padding: '3px 8px',
    background: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
  },

  footer: {
    marginTop: '25px',
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default EditorialChangePopup;
